import React from 'react';
import { 
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Divider,
  Link,
  Paper
} from '@mui/material';
import { Circle as CircleIcon } from '@mui/icons-material';

const LegalPage: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Avisos Legales y Términos de Uso
        </Typography>
        
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Última actualización: {new Date().toLocaleDateString()}
        </Typography>
        
        <Divider sx={{ my: 3 }} />
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          1. Propósito del Sitio Web
        </Typography>
        <Typography paragraph>
          Este sitio web tiene como objetivo compartir información y recomendaciones sobre lugares para salir con niños. 
          Los datos proporcionados son meramente informativos y pueden contener inexactitudes. 
          No nos hacemos responsables por decisiones tomadas en base a esta información.
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          2. Exención de Responsabilidad
        </Typography>
        <List>
          {[
            "La información publicada se obtiene de fuentes públicas y contribuciones de usuarios.",
            "No verificamos la exactitud de todos los datos proporcionados.",
            "Recomendamos siempre confirmar horarios, precios y disponibilidad directamente con los establecimientos.",
            "No nos responsabilizamos por cambios en los lugares mencionados ni por experiencias negativas."
          ].map((item, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <Typography variant="body1">{item}</Typography>
            </ListItem>
          ))}
        </List>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          3. Política de Imágenes
        </Typography>
        <Typography paragraph>
          Las imágenes utilizadas pueden provenir de:
        </Typography>
        <List>
          {[
            "Fuentes públicas y bancos de imágenes gratuitos",
            "Contribuciones de usuarios",
            "Capturas de sitios web públicos"
          ].map((item, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <Typography variant="body1">{item}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography paragraph>
          Si eres propietario de una imagen y deseas que sea removida, contáctanos inmediatamente a{' '}
          <Link href="mailto:contacto@chicosxbaires.com.ar" color="secondary">contacto@chicosxbaires.com.ar</Link>{' '}
          con la URL y prueba de propiedad.
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          4. Derechos de Autor y Uso Justo ("Fair Use")
        </Typography>
        <Typography paragraph>
          Este sitio opera bajo los principios de "uso justo" (Fair Use) para:
        </Typography>
        <List>
          {[
            "Propósitos educativos e informativos",
            "Crítica y comentario",
            "Investigación sin fines de lucro"
          ].map((item, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <Typography variant="body1">{item}</Typography>
            </ListItem>
          ))}
        </List>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          5. Limitación de Responsabilidad
        </Typography>
        <Typography paragraph>
          El uso de la información de este sitio es bajo tu propio riesgo. En ningún caso seremos responsables por:
        </Typography>
        <List>
          {[
            "Daños directos, indirectos o consecuentes",
            "Pérdidas o gastos resultantes del uso de esta información",
            "Errores u omisiones en el contenido"
          ].map((item, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <CircleIcon sx={{ fontSize: 8 }} />
              </ListItemIcon>
              <Typography variant="body1">{item}</Typography>
            </ListItem>
          ))}
        </List>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          6. Contribuciones de Usuarios
        </Typography>
        <Typography paragraph>
          Los usuarios pueden enviar información pero deben garantizar que no violan derechos de terceros.
          Nos reservamos el derecho de editar o eliminar contenido que consideremos inapropiado.
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          7. Enlaces Externos
        </Typography>
        <Typography paragraph>
          No somos responsables por el contenido de sitios enlazados ni por prácticas de privacidad de terceros.
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          8. Política de Privacidad
        </Typography>
        <Typography paragraph>
          Para solicitudes de eliminación de contenido o consultas sobre privacidad, por favor contáctanos a{' '}
          <Link href="mailto:contacto@chicosxbaires.com.ar" color="secondary">contacto@chicosxbaires.com.ar</Link>.
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4, fontWeight: 'bold' }}>
          9. Cambios en los Términos
        </Typography>
        <Typography paragraph>
          Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor 
          inmediatamente después de su publicación en el sitio.
        </Typography>
      </Paper>
    </Box>
  );
};

export default LegalPage;